import { render, staticRenderFns } from "./preview_5.vue?vue&type=template&id=964479e2&scoped=true"
import script from "./preview_5.vue?vue&type=script&lang=js"
export * from "./preview_5.vue?vue&type=script&lang=js"
import style0 from "./preview_5.vue?vue&type=style&index=0&id=964479e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964479e2",
  null
  
)

export default component.exports